module.exports = __webpack_public_path__ + "static/media/rock-mobile.ceea009c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/rock-mobile.jpg
// module id = 37
// module chunks = 0